import React from 'react';

const Logo = (props) => {
  return (
    <img
      height="50px"
      width="50px"
      alt="Logo"
      src="/static/slock.png"
      {...props}
    />
  );
};

export default Logo;
